const classNames = (classes) => {
  const toBeClasses = Object.keys(classes).map((key) => classes[key] === true ? key : '')
  return toBeClasses.join(' ')
}

export default classNames
